import { Injectable } from '@angular/core';

@Injectable()
export class StatisticsService {
	// TODO This service can be removed after upgrading to Angular 7.2
	// Replace with:
	// this.router.navigate(['/analytics/statistics'], {state: {data: {...}}});
	// To retrieve the data: history.state.data

	public data: any;
}
